
import React, {useEffect, useState} from 'react';


import {connect} from 'react-redux';
import LoftyDropdownComponent from '../../components/loftydropdowncomponent';
import LoftyCountDown from '../../components/loftycountdown';

import { addLoftyToken, deleteLoftytoken } from '../../actions/auth.actions';

import {customcreartuvj1_676339f09ccea34376cf813a } from '../../api/formulariocontactanos3lmag.api'

import './proveedores8vi4u.scss';


// Hamburger
function loftyInitHam() {
  try {
  // eslint-disable-next-line no-restricted-globals
    window.addEventListener('click', (event) => {
      let originPointLeft = '';
      const comp = event.target.className;
      if (comp.includes('menu__btn') || comp.includes('span_middle') || comp.includes('span_before') || comp.includes('span_after')) {
        const res = Array.from(document.getElementsByClassName('menu__box'));
        const spanData = Array.from(document.getElementsByClassName('menu__btn'));
        const closeBtn = Array.from(document.getElementsByClassName('menu__close__btn'));
        spanData.forEach((item) => {
          originPointLeft = item.style.left;
        });
        res.forEach((item) => {
          item.style.left = '0px';
        });
        spanData.forEach((item) => {
          item.style.left = '-300px';
        });
        closeBtn.forEach((item) => {
          item.style.left = '10px';
        });
      } else {
        if (comp === 'menu__box') {
          return;
        }
        if (comp === 'linkshref') {
          return;
        }
        if (comp === 'menu__item') {
          return;
        }
        const res = Array.from(document.getElementsByClassName('menu__box'));
        const spanData = Array.from(document.getElementsByClassName('menu__btn'));
        const closeBtn = Array.from(document.getElementsByClassName('menu__close__btn'));
        res.forEach((item) => {
          item.style.left = '-300px';
        });
        spanData.forEach((item) => {
          item.style.left = originPointLeft;
        });
        closeBtn.forEach((item) => {
          item.style.left = '-100%';
        });
      }
    });
  } catch (error) {
    // console.log(error);
  }
}    
    




const Pproveedores8vi4u = ({
  match,
  history,
  loftytoken,
  loftyuser,
  addLoftyUserApp,
  deleteLoftytokenApp,
  addLoftyTokenApp,
  
}) => {


useEffect(() => {
		const loftyHandleData = async () => {
		}
		loftyHandleData();
	}, []);


  
  setTimeout(() => { loftyInitHam(); }, 2000);

  
  

  
  return (
    <div id="id6755f00a1de4874021c1933a" >

      <div id="iw4j" className="">
      
      <div id="ips2" className="">
      
      <div id="itmdc" className="">
      
      <a
        target=""
        className=""
        id="i2aqf"
        href="/"
        type="button"
      >
        
    <div id="i2g1w" className="">
    <span>Inicio</span>
    </div>
    
      </a>
      
      <a
        target=""
        className=""
        id="iwu1w"
        href="/sobrenosotros"
        type="button"
      >
        
    <div id="ib1qi" className="">
    <span>Sobre Nosotros</span>
    </div>
    
      </a>
      
      <a
        target=""
        className=""
        id="i31ek"
        href="/servicios"
        type="button"
      >
        
    <div id="ipu5h" className="">
    <span>Servicios</span>
    </div>
    
      </a>
      
      </div>
      
      <div
        id="i7qon4"
        className=""
        data-aos="zoom-out-down"
        data-aos-duration="1500"
      >
      
      <img
        className=""
        id="ismeq"
        src="https://assetsprojects.s3.amazonaws.com/404no3im4afizry.png"
        alt="undefined"
      />
      
      </div>
      
      <div id="iacot" className="">
      
      <a
        target=""
        className=""
        id="i2hsg"
        href="/contrata"
        type="button"
      >
        
    <div id="ij3vk" className="">
    <span>Contrata</span>
    </div>
    
      </a>
      
      <a
        target=""
        className=""
        id="im06bc"
        href="/contacto"
        type="button"
      >
        
    <div id="ifflju" className="">
    <span>Contacto</span>
    </div>
    
      </a>
      
      <a
        target=""
        className=""
        id="ixxmu"
        href="/proveedores"
        type="button"
      >
        
    <div id="ikc1x" className="">
    <span>Proveedores</span>
    </div>
    
      </a>
      
      </div>
      
      <div id="icq3pj" className="">
      
      <div id="" className="contentwrapperanimated ">
      
      <div id="" className="container_animated ">
      
      <label id="" className="menu__btn ">
      
      <span className="span_before " id="">
        
      </span>
      
      <span className="span_middle " id="">
        
      </span>
      
      <span className="span_after " id="">
        
      </span>
      
      </label>
      
      <label id="" className="menu__close__btn ">
      
      <span className="span__close__left " id="">
        
      </span>
      
      <span className="span__close__right " id="">
        
      </span>
      
      </label>
      
      <ul id="" className="menu__box ">
        
      <li className="linkshref " id="">
        
      <a
        target=""
        className="menu__item "
        id=""
        href="/"
        type=""
      >
        <span>Inicio</span>
      </a>
      
      </li>
      
      <li className="linkshref " id="">
        
      <a
        target=""
        className="menu__item "
        id=""
        href="/sobrenosotros"
        type=""
      >
        <span>Sobre Nosotros</span>
      </a>
      
      </li>
      
      <li className="linkshref " id="">
        
      <a
        target=""
        className="menu__item "
        id=""
        href="/servicios"
        type=""
      >
        <span>Servicios</span>
      </a>
      
      </li>
      
      <li className="linkshref " id="">
        
      <a
        target=""
        className="menu__item "
        id=""
        href="/contrata"
        type=""
      >
        <span>Contrata</span>
      </a>
      
      </li>
      
      <li className="linkshref " id="">
        
      <a
        target=""
        className="menu__item "
        id=""
        href="/contacto"
        type=""
      >
        <span>Contacto</span>
      </a>
      
      <a
        target=""
        className="menu__item "
        id=""
        href="/proveedores"
        type=""
      >
        <span>Proveedores</span>
      </a>
      
      </li>
      
      </ul>
      
      </div>
      
      </div>
      
      </div>
      
      </div>
      
      <div id="i17hyw" className="">
      
      </div>
      
      <div
        id="in2hac"
        className=""
        data-aos="fade-up"
        data-aos-duration="2000"
      >
      
      <div id="iz8mng" className="">
      
      <div id="io8y2k" className="">
      
      <div id="iuhg3b" className="">
      
    <div id="i4z4a8" className="">
    
    </div>
    
      <p className="" id="i4kgfg">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="i510kh">
        <span>Una Plataforma para Todos</span>
      </span>
      
      </p>
      
      </div>
      
      <p className="" id="ixk7il">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="it4rio">
        <span>PROVEEDORES</span>
      </span>
      
      </p>
      
      </div>
      
      </div>
      
      </div>
      
      <div id="ima16j" className="">
      
      </div>
      
      <div id="ipenyj" className="">
      
      <div id="iaj45f" className="">
      
      <div id="iqmiq4" className="">
      
      <img
        className=""
        id="izmg0r"
        src="https://assetsprojects.s3.amazonaws.com/404no3im4fzlcnr.png"
        alt="undefined"
      />
      
      <p className="" id="iihgx4">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="ip3a36">
        <span>En Ineven, valoramos cada una de estas cualidades.</span>
      <br className="" id="" />
      <span>Si eres un proveedor de servicios en el mundo de los eventos, te invitamos a unirte a nuestra plataforma y ser parte de momentos inolvidables.</span>
      </span>
      
      </p>
      
      </div>
      
      <div id="i2mnxx" className="">
      
      <div id="ij3byz" className="">
      
      </div>
      
      <p className="" id="i36g73">
        <span>UN EMPRENDEDOR TIENE...</span>
      </p>
      
      </div>
      
      </div>
      
      </div>
      
      <div id="io4l7f" className="">
      
      </div>
      
      <div id="i5ox2h" className="">
      
      <div
        id="ihvfpk"
        className=""
        data-aos="fade-left"
        data-aos-duration="2000"
      >
      
      <div id="i1wqjn" className="">
      
      <p className="" id="ixzlxl">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="i9rtwu">
        <span>¿Por Qué Unirte a INEVEN?</span>
      </span>
      
      </p>
      
      <div id="ises2t" className="">
      
      </div>
      
      </div>
      
      </div>
      
      <div
        id="icheyi"
        className=""
        data-aos="fade-up"
        data-aos-duration="2000"
      >
      
      <div id="iu0j9q" className="">
      
      <div id="iwdupl" className="">
      
      <p className="" id="i7p6og">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="ig3xaq">
        <span>Amplia tu Alcance</span>
      </span>
      
      </p>
      
      <p className="" id="id59ri">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="iom1nn">
        <span>Presenta tus talentos y servicios a futuros esposos, cumpleañeros y organizadores de eventos que buscan servicios excepcionales y únicos.</span>
      </span>
      
      </p>
      
      </div>
      
      <div id="idnz6h" className="">
      
      <img
        className=""
        id="icb1fb"
        src="https://assetsprojects.s3.amazonaws.com/404no3im4fzsyad.png"
        alt="undefined"
      />
      
      </div>
      
      </div>
      
      </div>
      
      <div id="ivfesf" className="">
      
      </div>
      
      </div>
      
      <div id="itahp1" className="">
      
      <div
        id="iyy0eg"
        className=""
        data-aos="fade-up"
        data-aos-duration="2000"
      >
      
      <div id="iduhc9" className="">
      
      <div id="ifa5eb" className="">
      
      <img
        className=""
        id="i5ebz7"
        src="https://assetsprojects.s3.amazonaws.com/404no3im4fzvnxg.png"
        alt="undefined"
      />
      
      </div>
      
      <div id="iq3c5q" className="">
      
      <p className="" id="iun3sd">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="ivca0l">
        <span>Promoción Efectiva</span>
      </span>
      
      </p>
      
      <p className="" id="i1uh33">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="ihfswt">
        <span>Aprovecha nuestras estrategias de marketing para promocionar tus servicios de manera efectiva. Nuestra plataforma te brinda visibilidad y te ayuda a destacarte en el competitivo mercado de eventos.</span>
      </span>
      
      </p>
      
      </div>
      
      </div>
      
      </div>
      
      <div id="iq6j8a" className="">
      
      <div id="ip6v9d" className="">
      
      </div>
      
      </div>
      
      </div>
      
      <div id="i5q0wx" className="">
      
      <div
        id="i8ms6l"
        className=""
        data-aos="fade-up"
        data-aos-duration="2000"
      >
      
      <div id="ipe58t" className="">
      
      <div id="imjjdd" className="">
      
      <p className="" id="iqq97z">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="iyngpf">
        <span>Colaboración y Crecimiento</span>
      </span>
      
      </p>
      
      <p className="" id="irnsl4">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="i6dnux">
        <span>Presenta tus talentos y servicios a futuros esposos, cumpleañeros y organizadores de eventos que buscan servicios excepcionales y únicos.</span>
      </span>
      
      </p>
      
      </div>
      
      <div id="ijfuvg" className="">
      
      <img
        className=""
        id="ib7y5g"
        src="https://assetsprojects.s3.amazonaws.com/404no3im4fzxtog.png"
        alt="undefined"
      />
      
      </div>
      
      </div>
      
      </div>
      
      <div id="i226y5" className="">
      
      <div id="i9k5i4" className="">
      
      </div>
      
      </div>
      
      </div>
      
      <div id="i8xcok" className="">
      
      <div
        id="i3av9g"
        className=""
        data-aos="fade-up"
        data-aos-duration="2000"
      >
      
      <div id="i1xu6p" className="">
      
      <div id="iwf107" className="">
      
      <img
        className=""
        id="iwai2g"
        src="https://assetsprojects.s3.amazonaws.com/404no3im4fzzjx7.png"
        alt="undefined"
      />
      
      </div>
      
      <div id="i2012b" className="">
      
      <p className="" id="ics2tx">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="i7zmtt">
        <span>Colaboración y Crecimiento</span>
      </span>
      
      </p>
      
      <p className="" id="i2zoul">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="irvj0w">
        <span>Presenta tus talentos y servicios a futuros esposos, cumpleañeros y organizadores de eventos que buscan servicios excepcionales y únicos.</span>
      </span>
      
      </p>
      
      </div>
      
      </div>
      
      </div>
      
      </div>
      
      <div id="iaixk8" className="">
      
      </div>
      
      <div id="i0me7i" className="">
      
      <div id="iz02aa" className="">
      
      <p className="" id="ignbj6">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="iq1uji">
        <span>Cómo Unirse a Ineven Como Proveedor</span>
      </span>
      
      </p>
      
      <div id="ijq4ei" className="">
      
      <div id="ilzfkg" className="">
      
      </div>
      
      <p className="" id="iks9hm">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="i7b77f">
        <span>En cada uno de estos eventos, nuestra misión es superar tus expectativas y crear momentos que perduren en la memoria.</span>
      </span>
      
      </p>
      
      <div id="i01735" className="">
      
      </div>
      
      </div>
      
      </div>
      
      </div>
      
      <div id="iy4cuf" className="">
      
      </div>
      
      <div id="iu9o9w" className="">
      
      <div
        id="igq66r"
        className=""
        data-aos="flip-left"
        data-aos-duration="2000"
      >
      
      <div id="iq0xmv" className="">
      
      <img
        className=""
        id="im3q8x"
        src="https://assetsprojects.s3.amazonaws.com/404no3im4g0e9xy.png"
        alt="undefined"
      />
      
      <p className="" id="iesebq">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="ie10d2">
        <span>Registro Sencillo</span>
      </span>
      
      </p>
      
      <p className="" id="i6y0ei">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="imsn3c">
        <span>Regístrate en nuestra plataforma en unos simples pasos y crea tu perfil. Cuéntanos sobre tus servicios, tu experiencia y tus valores.</span>
      </span>
      
      </p>
      
      </div>
      
      </div>
      
      <div
        id="ib9rfk"
        className=""
        data-aos="flip-left"
        data-aos-duration="2000"
      >
      
      <div id="iehyek" className="">
      
      <img
        className=""
        id="ih9afl"
        src="https://assetsprojects.s3.amazonaws.com/404no3im4g0edyq.png"
        alt="undefined"
      />
      
      <p className="" id="icodkx">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="i0o8b5">
        <span>Destaca tu Talento</span>
      </span>
      
      </p>
      
      <p className="" id="i6pvcg">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="if2j8r">
        <span>Regístrate en nuestra plataforma en unos simples pasos y crea tu perfil. Cuéntanos sobre tus servicios, tu experiencia y tus valores.</span>
      </span>
      
      </p>
      
      </div>
      
      </div>
      
      </div>
      
      <div id="i8q9nn" className="">
      
      <div
        id="id9d84"
        className=""
        data-aos="flip-right"
        data-aos-duration="2000"
      >
      
      <div id="i4dnzd" className="">
      
      <img
        className=""
        id="ixvgfo"
        src="https://assetsprojects.s3.amazonaws.com/404no3im4g0ei4e.png"
        alt="undefined"
      />
      
      <p className="" id="icp5sc">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="i15k2f">
        <span>Colaborar y Crecer</span>
      </span>
      
      </p>
      
      <p className="" id="i316mk">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="ise15n">
        <span>Regístrate en nuestra plataforma en unos simples pasos y crea tu perfil. Cuéntanos sobre tus servicios, tu experiencia y tus valores.</span>
      </span>
      
      </p>
      
      </div>
      
      </div>
      
      <div
        id="ivjzkf"
        className=""
        data-aos="flip-right"
        data-aos-duration="2000"
      >
      
      <div id="ijynwq" className="">
      
      <img
        className=""
        id="ih46wz"
        src="https://assetsprojects.s3.amazonaws.com/404no3im4g0esyf.png"
        alt="undefined"
      />
      
      <p className="" id="iez44c">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="id5l4w">
        <span>Conecta con Clientes</span>
      </span>
      
      </p>
      
      <p className="" id="ioqf8e">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="it1k4l">
        <span>Regístrate en nuestra plataforma en unos simples pasos y crea tu perfil. Cuéntanos sobre tus servicios, tu experiencia y tus valores.</span>
      </span>
      
      </p>
      
      </div>
      
      </div>
      
      </div>
      
      <div id="ir6wyt" className="">
      
      </div>
      
      <div id="i9goi1" className="">
      
      <div id="ip0qxf" className="">
      
      <div id="i68cuj" className="">
      
      <p className="" id="iszk86">
        
      <span className="" id="iw7wzt">
        <span>Comienza tu Historia con Ineven</span>
      </span>
      
      </p>
      
      </div>
      
      <div id="i0s6tp" className="">
      
      <div id="iimphx" className="">
      
      <p className="" id="ids9we">
        
      <span className="" id="iofwwf">
        <span>¡Estamos emocionados por unirnos a ti en esta historia creativa!.</span>
      </span>
      
      </p>
      
      <p className="" id="i6p7lb">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="ia7jlg">
        <span>Estamos emocionados por unirnos a ti en este viaje creativo.</span>
      </span>
      
      </p>
      
      </div>
      
      <div id="icl0bc" className="">
      
      <p className="" id="irk6nw">
        
      <span className="" id="iiplmf">
        <span>Cuéntanos tus ideas</span>
      </span>
      
      </p>
      
      <p className="" id="iu4rfo">
        <span>Cuéntanos tus ideas</span>
      </p>
      
      <div id="icbmav" className="">
      <span>Ingresa tus datos</span>
      </div>
      
        <div className="" id="i8klm9">
          
      <form
        id="in8wox"
        className=""
        onSubmit={async (e) => {
				e.preventDefault();
				try {
						const lofty_response = await customcreartuvj1_676339f09ccea34376cf813a({
						nombreo31bw: e.target.nombreo31bw.value,
						telefono71bhf: e.target.telefono71bhf.value,
						correov6gp1l: e.target.correov6gp1l.value,
						cuentanostuideakfptok: e.target.cuentanostuideakfptok.value,
					});
					alert("Se agregó exitosamente");
		} catch (error) {
					console.log(error);
				}
			}}
		
      >
        
      <div id="igjx72" className="">
      
      <br className="" id="" />
      
      <input
        name="nombreo31bw"
        type="text"
        placeholder="Nombre"
        className="camposFormulario "
        id="ihtzm6"
      />
      
      </div>
      
      <div id="id1n5j" className="">
      
      <br className="" id="" />
      
      <input
        name="telefono71bhf"
        type="text"
        placeholder="Telefono"
        className="camposFormulario "
        id="irj3pa"
      />
      
      </div>
      
      <div id="iwazhi" className="">
      
      <br className="" id="" />
      
      <input
        name="correov6gp1l"
        type="text"
        placeholder="Correo"
        className="camposFormulario "
        id="i9k9tf"
      />
      
      </div>
      
      <div id="ich4b4" className="">
      
      <br className="" id="" />
      
      <input
        name="cuentanostuideakfptok"
        type="text"
        placeholder="Cuentanos tu Idea"
        className="camposFormulario "
        id="io84ff"
      />
      
      </div>
      
      <button
        type="submit"
        name=""
        id="iijknx"
        className=""
        
      >
      
      <div id="i3z3yk" className="">
      <span>Enviar</span>
      </div>
      
      </button>
      
      </form>
      
        </div>
        
      <div id="iym77j" className="">
      
      <p className="" id="iynyxj">
        
      <span className="" id="ikcb1k">
        <span>¿Eres proveedor?</span>
      </span>
      
      </p>
      
        <a
          target=""
          className=""
          id="iowpze"
          href="#"
        >
          
    <div id="ioqyiy" className="">
    
      <span className="" id="ig5j4r">
        <span>Encuentra</span>
      </span>
      
    </div>
    
        </a>
        
      <p className="" id="iebja3">
        
      <span className="" id="ii5d7c">
        <span>nuevos clientes</span>
      </span>
      
      </p>
      
      </div>
      
      </div>
      
      </div>
      
      </div>
      
      </div>
      
      <div id="ir2czw" className="">
      
      </div>
      
      <div id="icohi" className="">
      
      <div id="iyghfd" className="">
      
      <div id="i52pnr" className="">
      
      <img
        className=""
        id="imi9j3"
        src="https://assetsprojects.s3.amazonaws.com/404no3im4afizry.png"
        alt="undefined"
      />
      
      <p className="" id="iyo7r6">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="il8o0q">
        <span>Ingenieria de eventos.</span>
      </span>
      
      </p>
      
      </div>
      
      <div id="id3akf" className="">
      
      <div id="ipwalf" className="">
      
      <img
        className=""
        id="icnrzk"
        src="https://assetsprojects.s3.amazonaws.com/404no3im4vijr82.png"
        alt="undefined"
      />
      
        <a
          target="_blank"
          className=""
          id="iwxasl"
          href="https://www.tiktok.com/@ineven.vip?_t=8sKdB0x1PBG&_r=1"
        >
          
    <div id="ipvb6o" className="">
    <span>ineven.vip</span>
    </div>
    
        </a>
        
      </div>
      
      <div id="iy0qky" className="">
      
      <img
        className=""
        id="i2e7ky"
        src="https://assetsprojects.s3.amazonaws.com/404no3im4bmczdi.png"
        alt="undefined"
      />
      
        <a
          target="_blank"
          className=""
          id="iktz9i"
          href="https://www.facebook.com/ineven.vip"
        >
          
    <div id="ie65ch" className="">
    <span>ineven.vip</span>
    </div>
    
        </a>
        
      </div>
      
      <div id="igk236" className="">
      
      <img
        className=""
        id="i9z0pd"
        src="https://assetsprojects.s3.amazonaws.com/404no3im4bmd43v.png"
        alt="undefined"
      />
      
        <a
          target="_blank"
          className=""
          id="in7xsd"
          href="https://www.instagram.com/ineven.vip?igsh=b25xZHA5MDVqaDVp"
        >
          
    <div id="i5t2yb" className="">
    <span>@ineven.vip</span>
    </div>
    
        </a>
        
      </div>
      
      <div id="io5w49" className="">
      
      <img
        className=""
        id="i6uigw"
        src="https://assetsprojects.s3.amazonaws.com/404no3im4viijg2.png"
        alt="undefined"
      />
      
        <a
          target="_blank"
          className=""
          id="ilkwdo"
          href="https://www.linkedin.com/company/ineven/"
        >
          
    <div id="i27jt6" className="">
    <span>ineven.vip</span>
    </div>
    
        </a>
        
      </div>
      
      </div>
      
      <div id="i1rlot" className="">
      
      <p className="" id="iw7za7">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="ic71jf">
        
      <a
        target=""
        className=""
        id="i3tw8c"
        href="/sobrenosotros"
        type=""
      >
        <span>Sobre nosotros</span>
      </a>
      
      </span>
      
      </p>
      
      <p className="" id="i3340b">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="ih08ak">
        
      <a
        target=""
        className=""
        id="if9iq4"
        href="/servicios"
        type=""
      >
        <span>Nuestros servicios</span>
      </a>
      
      </span>
      
      </p>
      
      <p className="" id="ijqtal">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="itkfgw">
        
      <a
        target=""
        className=""
        id="igrelc"
        href="/contrata"
        type=""
      >
        <span>Hazlo tú mismo</span>
      </a>
      
      </span>
      
      </p>
      
      <p className="" id="ik2e3t">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="it8v73">
        
      <a
        target=""
        className=""
        id="it65mq"
        href="/proveedores"
        type=""
      >
        <span>Testimonio</span>
      </a>
      
      </span>
      
      </p>
      
      <p className="" id="i38bqt">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="ib7tnq">
        
      <a
        target=""
        className=""
        id="irytmj"
        href="/contacto"
        type=""
      >
        <span>Contáctanos</span>
      </a>
      
      </span>
      
      </p>
      
      </div>
      
      <div id="ipuzkj" className="">
      
      <p className="" id="ifh7p5">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="ita68z">
        <span>+504 9574-8270</span>
      </span>
      
      </p>
      
      <p className="" id="i78qcc">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="imjhna">
        <span>Col. Colonia, 7 calle, 8 avenida S.O</span>
      </span>
      
      </p>
      
      <p className="" id="il1rnw">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="i6f3bu">
        <span>ingenierodeevento@gmail.com</span>
      </span>
      
      </p>
      
      </div>
      
      </div>
      
      <div id="iou1pv" className="">
      
      <p className="" id="izq2dp">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="ieap6m">
        <span>Todos los derechos reservados - Ineven - 2022 </span>
      </span>
      
      </p>
      
      </div>
      
      </div>
      
      </div>
      
</div>
  );
}

const mapStateToProps = (state) => state.auth;

const mapDispatchToProps = (dispatch) => ({
 addLoftyTokenApp: (data) => dispatch(addLoftyToken(data)),
 deleteLoftytokenApp: () => dispatch(deleteLoftytoken()),
});


export default connect(mapStateToProps, mapDispatchToProps)(Pproveedores8vi4u);
  